import type { IconProp } from "@fortawesome/fontawesome-svg-core"
import { faChartSimple } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Animate, { AnimationTypes } from "../../../components/Animate/Animate"

interface FinancialEmptyStateProps {
  title: string
  description?: string
  icon?: IconProp
  compact?: boolean
}

export const FinancialEmptyState: React.FC<FinancialEmptyStateProps> = ({
  title,
  description,
  icon = faChartSimple,
  compact = false,
}) => (
  <Animate type={AnimationTypes.fadeIn} duration="0.4s">
    <div
      className={`flex flex-col items-center justify-center rounded-xl border border-dashed border-slate-300 bg-slate-50 px-4 text-center ${compact ? "min-h-32 py-5" : "min-h-56 py-8"}`}
    >
      <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white text-slate-400 shadow-sm" aria-hidden="true">
        <FontAwesomeIcon icon={icon} />
      </span>
      <p className="mt-3 text-sm font-extrabold text-slate-700">{title}</p>
      {description && <p className="mt-1 max-w-md text-xs font-medium leading-5 text-slate-500">{description}</p>}
    </div>
  </Animate>
)
